export default function DiscardSeatOnTravellerChangeService() {
    Object.assign(this, {
        hasTravellerInformationBeenChanged,
    });

    function hasTravellerInformationBeenChanged(oneTraveller, anotherTraveller) {
        return !angular.equals({
            Id: getValue(oneTraveller.Id),
            AdultTripPassengerId: getValue(oneTraveller.AdultTripPassengerId),
            Title: getValue(oneTraveller.Title),
            FirstName: getValue(oneTraveller.FirstName),
            MiddleName: getValue(oneTraveller.MiddleName),
            LastName: getValue(oneTraveller.LastName),
            PassengerType: getValue(oneTraveller.PassengerType),
            EmailAddress: getValue(oneTraveller.EmailAddress),
            TelephoneNumberCallingCode: getValue(oneTraveller.TelephoneNumberCallingCode),
            TelephoneNumber: getValue(oneTraveller.TelephoneNumber),
            KnownTravellerNumber: getValue(oneTraveller.TravellerFlightDetails.KnownTravellerNumber),
            RedressNumber: getValue(oneTraveller.TravellerFlightDetails.RedressNumber),
            Gender: getValue(oneTraveller.TravellerFlightDetails.Gender),
            DateOfBirth: getValue(oneTraveller.TravellerFlightDetails.DateOfBirth),
            PassportNumber: getValue(oneTraveller.TravellerFlightDetails.PassportNumber),
            PassportExpiryDate: getValue(oneTraveller.TravellerFlightDetails.PassportExpiryDate),
            PassportIssuingCountryCode: getValue(oneTraveller.TravellerFlightDetails.PassportIssuingCountryCode),
            NationalityCode: getValue(oneTraveller.TravellerFlightDetails.NationalityCode),
        }, {
            Id: getValue(anotherTraveller.Id),
            AdultTripPassengerId: getValue(anotherTraveller.AdultTripPassengerId),
            Title: getValue(anotherTraveller.Title),
            FirstName: getValue(anotherTraveller.FirstName),
            MiddleName: getValue(anotherTraveller.MiddleName),
            LastName: getValue(anotherTraveller.LastName),
            PassengerType: getValue(anotherTraveller.PassengerType),
            EmailAddress: getValue(anotherTraveller.EmailAddress),
            TelephoneNumberCallingCode: getValue(anotherTraveller.TelephoneNumberCallingCode),
            TelephoneNumber: getValue(anotherTraveller.TelephoneNumber),
            KnownTravellerNumber: getValue(anotherTraveller.TravellerFlightDetails.KnownTravellerNumber),
            RedressNumber: getValue(anotherTraveller.TravellerFlightDetails.RedressNumber),
            Gender: getValue(anotherTraveller.TravellerFlightDetails.Gender),
            DateOfBirth: getValue(anotherTraveller.TravellerFlightDetails.DateOfBirth),
            PassportNumber: getValue(anotherTraveller.TravellerFlightDetails.PassportNumber),
            PassportExpiryDate: getValue(anotherTraveller.TravellerFlightDetails.PassportExpiryDate),
            PassportIssuingCountryCode: getValue(anotherTraveller.TravellerFlightDetails.PassportIssuingCountryCode),
            NationalityCode: getValue(anotherTraveller.TravellerFlightDetails.NationalityCode),
        });
    }

    function getValue(source) {
        return source && source.hasOwnProperty('value') ? source.value : source;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/traveller/discard-seat-on-traveller-change/discard-seat-on-traveller-change-service.js